module.exports = __webpack_public_path__ + "img/bg 02 yellow.4c3d90d3.png";